module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "layout-fw home-wrapper"
  }, [_c('div', {
    staticClass: "layout-fix layout-tl layout-fw home-nav layout-cc"
  }, [_c('div', {
    staticClass: "home-container home-nav-h"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom-row layout-fw"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "nav-breadcrums is-home"
  }, [_vm._v("Home")])]), _vm._v(" "), _c('span', {
    staticClass: "nav-breadcrums"
  }, [_vm._v("modern-javascript-basics")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentEgIdx),
      expression: "currentEgIdx"
    }],
    staticClass: "nav-breadcrums-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentEgIdx = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.examples), function(example, exampleID) {
    return _c('option', {
      domProps: {
        "value": exampleID
      }
    }, [_vm._v(_vm._s(example.title))])
  })), _vm._v(" "), (_vm.currentExample) ? _c('form', {
    on: {
      "submit": function($event) {
        _vm.saveTitle(_vm.updatedTitle)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.currentExample.title
    },
    on: {
      "input": function (evt) {
        this$1.updatedTitle = evt.target.value;
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "update title"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.removeExample(_vm.currentExample)
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.addExample
    }
  }, [_vm._v("\n            Add new: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTitle),
      expression: "newTitle"
    }],
    domProps: {
      "value": (_vm.newTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTitle = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "layout-fw layout-hc"
  }, [_c('div', {
    staticClass: "home-container layout-fh"
  }, [_c('div', {
    staticClass: "home-padding"
  }, [(_vm.currentExample) ? _c('Coder', {
    attrs: {
      "example": _vm.currentExample
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-top-row layout-fw"
  }, [_c('h1', {
    staticClass: "lok-brand"
  }, [_vm._v("Lok Lok Academy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e3ba60e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive/CodeSample.vue
// module id = 303
// module chunks = 3